export default __webpack_public_path__ + "static/media/signout.929847b9.svg";